import React, { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

export default function ReportsAdmin() {
  const [r, setR] = useState(null);

  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)); }, []);

  return (
    <div data-testid="adm-reports-page">
      <PageHeader eyebrow="Reports" title="Platform analytics" subtitle="Top merchants, top users, performance benchmarks." />

      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="border-gray-200 shadow-none rounded-2xl">
          <CardContent className="p-6">
            <h3 className="font-display font-bold text-lg mb-4">Top merchants by GMV</h3>
            <ResponsiveContainer width="100%" height={320}>
              <BarChart data={r?.top_merchants || []}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
                <XAxis dataKey="merchant" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip formatter={(v) => fmtMoney(v)} />
                <Bar dataKey="gmv" fill="#0284c7" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card className="border-gray-200 shadow-none rounded-2xl">
          <CardContent className="p-6">
            <h3 className="font-display font-bold text-lg mb-4">Top users by cashback</h3>
            <table className="w-full text-sm">
              <thead className="border-b border-gray-200 text-left">
                <tr>
                  <th className="py-2 font-semibold">User</th>
                  <th className="py-2 font-semibold">Email</th>
                  <th className="py-2 font-semibold">Total cashback</th>
                </tr>
              </thead>
              <tbody>
                {(r?.top_users || []).map((u, i) => (
                  <tr key={i} className="border-b border-gray-100">
                    <td className="py-3 font-medium">{u.name}</td>
                    <td className="py-3 text-gray-600">{u.email}</td>
                    <td className="py-3 text-emerald-700 font-semibold">{fmtMoney(u.total_cashback)}</td>
                  </tr>
                ))}
                {(r?.top_users || []).length === 0 && <tr><td colSpan="3" className="py-6 text-center text-gray-500">No data yet.</td></tr>}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
